// extracted by mini-css-extract-plugin
export default {"textComponent":"styles_textComponent__GtNQy","textComponentExpanded":"styles_textComponentExpanded__rRplb"};